export const getFactoryList = (state) => {
    return state.factoryList;
};

export const getTotalizers = (state) => {
    return state.totalizers;
};

export const getPortTotalizers = (state) => {
    return state.portTotalizers;
};

export const getPortList = (state) => {
    return state.portList;
};
